import React from 'react'
import NetFlowsHeatmapChart, { resolveGeographySubtitleLabel } from './NetFlowsHeatmapShared'

const NetFlowsHeatmap = (props) => (
  <NetFlowsHeatmapChart
    {...props}
    rowAxisLabel="Investor type"
    resolveFilterSubtitleLabel={resolveGeographySubtitleLabel}
    accessibilityPointDescription="{series.xAxis.categories.(x)} net flow {series.yAxis.categories.(y)}, {value}."
  />
)

export default NetFlowsHeatmap
